/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../components.ts"/>


module DealerwareWebComponents {

    "use strict";


    export class ErrorContentDirectiveController {

        public static $inject : string[ ] = [
            'dealerwareErrorContentDefaults'
        ];

        public category     : any;
        public explanation  : any;
        public remedies     : any;

        constructor(
            private dealerwareErrorContentDefaults: any
        ) {
            this.category       = this.category     || dealerwareErrorContentDefaults.category;
            this.explanation    = this.explanation  || dealerwareErrorContentDefaults.explanation;
            this.remedies       = this.remedies     || dealerwareErrorContentDefaults.remedies;
        }
    }

    getDealerwareWebComponentsModule().controller(
        'ErrorContentDirectiveController',
        ErrorContentDirectiveController
    );

    export class ErrorContentDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ErrorContentDirectiveController';
        public controllerAs     : string    =   'errorContentController';
        public templateUrl      : string    =   '/components/errors/error-content-directive.html';
        public bindToController : Object    =   {
            category    : '=?',
            explanation : '=?',
            remedies    : '=?'
        };
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareErrorContent',
        ( ) => new ErrorContentDirective()
    )
    .constant('dealerwareErrorContentDefaults', {
         category       : 'Unknown error type',
         explanation    : 'An unknown error occurred.',
         remedies       : [ 'That\'s all we know.' ]
    });
}

